import type { Agent } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

export const getAgentIdFromAri = (ari: string): string | null => {
	// Pattern: ari:cloud:rovo::agent/activation/{uuid}/{uuid}
	const ariPattern =
		/^ari:cloud:rovo::agent\/activation\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/([^/]+)$/;

	const match = ari.match(ariPattern);
	if (!match) {
		return null;
	}
	// Return the second UUID (agent ID)
	return match[1];
};

export const transformAgentGqlResponse = (agentNode: any): Agent =>
	({
		creator_type: agentNode.creatorType,
		creator: agentNode.creator?.id,
		description: agentNode.description,
		external_config_reference: agentNode.externalConfigReference,
		favourite: agentNode.isFavourite,
		id: getAgentIdFromAri(agentNode.id) ?? '',
		agentAri: agentNode.id,
		identity_account_id: agentNode.identityAccountId,
		name: agentNode.name,
		user_defined_conversation_starters: agentNode.conversationStarters,
		icon: agentNode.icon,
		// We need named_id here as the FE requires it for certain features
		named_id: getAgentIdFromAri(agentNode.id) ?? '',
		authoring_team: agentNode?.authoringTeam
			? {
					id: agentNode.authoringTeam.id,
					profile_url: agentNode.authoringTeam.profileUrl,
					display_name: agentNode.authoringTeam.displayName,
					avatar_url: agentNode.authoringTeam.smallAvatarImageUrl,
				}
			: null,
		is_verified: agentNode.isVerified,
	}) as Agent;
